import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'fishx';
import { get } from 'lodash';
import { Form, Pagination, Spin, Button } from '@whalecloud/fdx';
import { PortalCardList } from '@/components';

import { renderFormItems, showTotal, renderField, DefaultJudeOpt } from '@/utils';
// import { DefaultPageInfo } from '../config';

import styles from './index.module.less';

const DefaultPageInfo = {
  currentPage: 1,
  pageSize: 8,
};

const OfferList = props => {
  const {
    modelKey,
    dispatchType = 'selectPlan/qryOfferList',
    currentOffer,
    onOfferChange,
    onDppChange,
    queryOfferParams,
    renderFun = {},
    cardKey = 'offerId',
    loading,
    dispatch,
    form,
  } = props;
  const { getFieldDecorator, resetFields, getFieldsValue } = form;
  const [offerArr, setOfferArr] = useState([]);
  const [searchInfo, setSearchInfo] = useState({});
  const [pageInfo, setPageInfo] = useState(DefaultPageInfo);
  const [total, setTotal] = useState(0);

  const defaultCombo = DefaultJudeOpt[0].value;

  const queryOffer = async (search = {}, page = {}) => {
    const payload = {
      isCombo: defaultCombo,
      ...search,
      ...queryOfferParams,
      pageInfo: {
        ...pageInfo,
        ...page,
      },
    };
    if (modelKey === 'virtualConvertToFixedLine') {
      // 虚转固查询可用offer的接口入参里的分页字段处理
      payload.pageDto = {
        pageIndex: pageInfo.currentPage,
        pageCount: pageInfo.pageSize,
      };
      delete payload.pageInfo;
    }
    dispatch({
      type: dispatchType,
      payload,
      modelName: modelKey,
    }).then((res = {}) => {
      const { offerList, pageDto = {} } = res;
      setOfferArr((offerList || []).map(offer => ({
        ...offer,
        isCombo: payload.isCombo !== defaultCombo, // offer列表增加isCombo字段
      })));
      setPageInfo({
        currentPage: pageDto.currentPage || DefaultPageInfo.currentPage,
        pageSize: pageDto.pageSize || DefaultPageInfo.pageSize,
      });
      if (pageDto.currentPage === 1) {
        setTotal(pageDto.total);
      }
    });
  };

  useEffect(() => {
    if (dispatchType) {
      queryOffer(); // 查询套餐
    }
  }, [dispatchType]);

  useEffect(() => {
    if (searchInfo.isCombo !== 'Y' && offerArr.length > 0) {
      onOfferChange(offerArr[0]);
      onDppChange((get(offerArr[0], 'dppOfferDtoList') || get(offerArr[0], 'offerExtMap.dppOfferDtoList') || [])[0] || {});
    } else {
      onOfferChange({});
    }
  }, [offerArr, searchInfo]);

  const handleFormQuery = () => {
    const { isCombo, offerName } = getFieldsValue();
    setSearchInfo({ isCombo, offerName });
    queryOffer({ isCombo, offerName }, pageInfo);
  };
  const handleFormReset = () => {
    resetFields();
    setPageInfo(DefaultPageInfo);
    queryOffer();
  };

  const handlePageInfoChange = page => {
    setPageInfo({
      ...pageInfo,
      currentPage: page,
    });
    queryOffer(searchInfo, { currentPage: page });
  };

  const SelectPlanFormItems = () => {
    const baseItems = [];

    if (dispatchType !== 'modifyPlan/qryAvailablePlanListBsnl' && dispatchType !== 'reconnection/qryAvailablePlanListBsnl') {
      baseItems.push({
        label: i18n('SELECT_OFFER_PLAN_NAME'),
        name: 'offerName',
        type: 'input',
      });
    }
    if (dispatchType !== 'selectPlan/qryOfferList') {
      return baseItems;
    }
    return [
      {
        label: 'Is Combo',
        name: 'isCombo',
        options: { rules: [{ required: true }], initialValue: defaultCombo },
        type: 'select',
        data: DefaultJudeOpt,
        renderField: renderField.renderFieldNormal,
        formItemCompProps: {
          onSelect: handleFormQuery || (() => {}),
        },
      },
      ...baseItems,
    ];
  };

  if (renderFun.renderOldOffer) {
    return renderFun.renderOldOffer();
  }
  return (
    <div className="blockWrap">
      <h3 className="blockTitle">{i18n('NEW_CONNECTION_SELECT_OFFER')}</h3>
      {['shift', 'transfer', 'reconnection'].includes(modelKey) && <span className="note">{i18n('OFFER_SELECTION_NOTE')}</span>}
      <div className={styles.contain}>
        <div className={styles.selectPlan}>
          <Form layout="inline" className={styles.offerForm}>
            <div className="formItemBox">
              {renderFormItems(SelectPlanFormItems(), getFieldDecorator)}
              {SelectPlanFormItems().length !== 0 && (
                <div className={styles.formBtns}>
                  <Button onClick={handleFormReset}>{i18n('BTN_RESET')}</Button>
                  <Button type="primary" onClick={handleFormQuery}>{i18n('BTN_QUERY')}</Button>
                </div>
              )}
            </div>
          </Form>
          <Spin spinning={loading}>
            <div className={styles.OfferContent}>
              <PortalCardList
                cardKey={cardKey}
                dataGroup={offerArr}
                defaultCardId={currentOffer.offerId}
                onClick={onOfferChange}
                onDppChange={onDppChange}
                // eslint-disable-next-line react/jsx-boolean-value
                selectPlanWithDpp={true}
              />
            </div>
            <div className={styles.footer}>
              {
                total > DefaultPageInfo.pageSize && (
                  <div className={styles.pagination}>
                    <Pagination
                      showQuickJumper
                      showTotal={showTotal}
                      total={total}
                      current={pageInfo.currentPage}
                      pageSize={pageInfo.pageSize}
                      onChange={handlePageInfoChange}
                    />
                  </div>
                )
              }
            </div>
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default connect((state, props) => ({
  loading: state.loading.effects[props.dispatchType || 'selectPlan/qryOfferList'],
}))(Form.create({ name: 'offerSearchForm' })(OfferList));
